import { useCallback, useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import BudgetCurrencyInput from './BudgetCurrencyInput';
import BudgetCounterProposalMobile from './mobile/BudgetCounterProposalMobile';

interface IBudgetCounterProposalProps {
  counterProposal?: boolean;
  counterProposalValue?: number;
  counterProposalObs?: string;
  onCounterProposalValueChange?: (value: number) => void;
  onCounterProposalObsChange?: (value: string) => void;
  disabled?: boolean;
}

const BudgetCounterProposal = (props: IBudgetCounterProposalProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [observation, setObservation] = useState<string>(props.counterProposalObs || '');
  const [value, setValue] = useState<number>(props.counterProposalValue || 0);

  useEffect(() => {
    setObservation(props.counterProposalObs || '');
  }, [props.counterProposalObs]);

  useEffect(() => {
    setValue(props.counterProposalValue || 0);
  }, [props.counterProposalValue]);

  const handleObservationChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      setObservation(newValue);
      props.onCounterProposalObsChange?.(newValue);
    },
    [props],
  );

  const handleValueChange = useCallback(
    (newValue: number) => {
      setValue(newValue);
      props.onCounterProposalValueChange?.(newValue);
    },
    [props],
  );

  if (isMobile) {
    return (
      <BudgetCounterProposalMobile
        counterProposal={props.counterProposal}
        counterProposalValue={value}
        counterProposalObs={observation}
        onCounterProposalValueChange={handleValueChange}
        onCounterProposalObsChange={(value) => setObservation(value)}
        disabled={props.disabled}
      />
    );
  }

  return (
    <div className="m-6 px-4 border-2 border-gray-100 rounded-md p-4">
      <div className="flex flex-row items-center mb-4">
        <div className="font-bold text-size-14 text-gray-700">Contraproposta</div>
      </div>

      <div className="flex flex-row gap-4">
        <div className="flex-1">
          <div className="font-bold mb-2 text-size-12 text-gray-500">Observação</div>
          <textarea
            className="form-control w-full"
            rows={1}
            placeholder="Insira um texto em caso de contraproposta"
            value={observation}
            onChange={handleObservationChange}
            disabled={props.disabled}
          />
        </div>

        <div className="w-45 ml-2">
          <div className="font-bold mb-2 text-size-12 text-gray-500">Valor da contraproposta</div>
          <BudgetCurrencyInput value={value} onChange={handleValueChange} placeholder="R$ 0,00" disabled={props.disabled} />
        </div>
      </div>
    </div>
  );
};

export default BudgetCounterProposal;
